import { render, staticRenderFns } from "./toplogoCustomer.vue?vue&type=template&id=3dfdfb78&"
import script from "./toplogoCustomer.vue?vue&type=script&lang=js&"
export * from "./toplogoCustomer.vue?vue&type=script&lang=js&"
import style0 from "./toplogoCustomer.vue?vue&type=style&index=0&id=3dfdfb78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports